import { createContext, useContext } from "react";

export type TemplatePreviewField = {
  to: string;
  template: string;
  /** Direct callback into TemplateInput's onChange — only works while popover is mounted */
  applyTemplate: (newTemplate: string) => void;
};

type TemplatePreviewContextType = {
  openPreview: (field: TemplatePreviewField) => void;
  /** True when the tester modal is open — popover should not close */
  isPreviewOpen: boolean;
};

export const TemplatePreviewContext =
  createContext<TemplatePreviewContextType | null>(null);

export const useTemplatePreview = () => useContext(TemplatePreviewContext);
